<template>
  <b-form @submit.prevent="onSubmit" enctype="multipart/form-data">
    <b-alert
      :show="msgSubmit.dismissCountDown"
      dismissible
      :variant="msgSubmit.variant"
      @dismissed="msgSubmit.dismissCountDown = 0"
      @dismiss-count-down="countDownChanged"
    >
      <p v-html="msgSubmit.msg" />

      <b-progress
        :variant="msgSubmit.variant"
        :max="msgSubmit.dismissSecs"
        :value="msgSubmit.dismissCountDown"
      ></b-progress>
    </b-alert>

    <b-card class="mb-4">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b>Arquivo e configurações</b>
          <div class="d-flex flex-row">
            <router-link
              :to="{
                name: 'oportunidades_list',
              }"
              class="btn btn-outline-muted mr-2"
              >Voltar para Listagem</router-link
            >
            <b-button type="submit" variant="exitos" :disabled="disabledSave">
              Importar
            </b-button>
          </div>
        </div>
      </template>

      <b-row>
        <b-col cols="6" md="9" lg="8">
          <b-form-group label="Selecionar arquivo">
            <div class="form-input-image-bg">
              <label :for="file_id" />
              <b-form-file
                v-model="file_csv"
                @change.prevent="changeFile"
                class="form-input-file"
                placeholder="Nenhum arquivo selecionado"
                drop-placeholder="Solte aqui"
                browse-text="Selecionar arquivo"
                accept="text/csv"
                :id="file_id"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="6" md="3" lg="4">
          <b-form-group label="Codificação">
            <b-select
              v-model="file_config.charset"
              :options="[
                { text: 'Codificação universal (UTF-8)', value: 'UTF-8' },
                {
                  text: 'Caractéres latinos (ISO-8859-1)',
                  value: 'ISO-8859-1',
                },
              ]"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Delimitador">
            <b-input v-model="file_config.delimiter" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Aspas">
            <b-input v-model="file_config.quote" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col> <TableConfig v-model="config_columns" /> </b-col>
      </b-row>
    </b-card>

    <b-card title="Informações do Arquivo" v-if="file_csv">
      <FileData
        ref="table-file-data"
        :file_data="file_data"
        :delimiter="file_config.delimiter"
        :quote="file_config.quote"
        :loading="loading"
        @loaded="loading = false"
        @statusValidacao="setStatusValidacao"
        :config_columns="config_columns"
      />
    </b-card>
  </b-form>
</template>

<script>
import { mapActions } from "vuex";
import FileData from "./FormImportarEmendas/FileData.vue";
import TableConfig from "./FormImportarEmendas/TableConfig.vue";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  components: { FileData, TableConfig },
  mixins: [validationMixin],
  data: () => ({
    file_csv: null,
    file_data: null,
    id: null,
    loading: false,
    file_config: {
      charset: "ISO-8859-1",
      delimiter: ";",
      quote: '"',
    },
    statusValidacao: "",
    config_columns: [],
    valores_importar: [],

    msgSubmit: {
      variant: "",
      msg: "",
      show: true,
      dismissSecs: 10,
      dismissCountDown: 0,
    },
  }),
  validations: {
    valores_importar: {
      required,
    },
  },
  computed: {
    file_id() {
      return "file-import-" + this.id;
    },
    disabledSave() {
      return this.statusValidacao != "finalizada";
    },
  },
  methods: {
    ...mapActions("oportunidades", ["ActionImportarEmendas"]),
    countDownChanged(dismissCountDown) {
      this.msgSubmit.dismissCountDown = dismissCountDown;
    },
    async onSubmit() {
      this.valores_importar = this.$refs["table-file-data"].itens;

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          const response = await this.ActionImportarEmendas(
            this.valores_importar
          );
          this.$refs["table-file-data"].itens = response.valores;

          let numErros = 0;
          for (const item of response) {
            numErros += item.registros - item.importados;
          }

          this.msgSubmit.dismissCountDown = this.msgSubmit.dismissSecs;
          if (numErros === 0) {
            this.msgSubmit.msg = "Importação realizada salvo com sucesso";
            this.msgSubmit.variant = "success";

            this.$notifications.addNotification({
              message: this.msgSubmit.msg,
              type: this.msgSubmit.variant,
            });
          } else {
            this.msgSubmit.msg =
              "A importação foi realizada<br/>" +
              "Porém " +
              numErros +
              " registros não puderam ser importados.";
            this.msgSubmit.variant = "danger";

            this.$notifications.addNotification({
              message:
                "A importação foi realizada<br/>" +
                "Porém " +
                numErros +
                " registros não puderam ser importados.",
              icon: "exclamation-triangle",
              type: "danger",
            });
          }
        } catch (error) {
          this.$notifications.addNotification({
            message: "Erro ao salvar",
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }
    },
    isValid() {
      this.$v.valores_importar.$touch();
      return !this.$v.valores_importar.$anyError;
    },
    async loadFile() {
      if (this.file_csv) {
        this.loading = true;
        const reader = new FileReader();
        const addReaderResult = () => {
          this.file_data = reader.result;
        };
        reader.addEventListener("load", addReaderResult.bind(this));
        reader.readAsText(this.file_csv, this.file_config.charset);
      }
    },
    changeFile(evt) {
      this.file_csv = evt.target.files[0];
      this.loadFile();

      if (!this.file_data || !this.file_csv) return;
      this.$notifications.addNotification({
        message:
          "O arquivo foi carregado, visualize abaixo para mais detalhes.",
        type: "success",
      });
    },
    setStatusValidacao(value) {
      this.statusValidacao = value;
    },
  },
  watch: {
    file_config: {
      deep: true,
      handler: function () {
        this.loadFile();
      },
    },
  },
  mounted() {
    this.id = this._uid;
  },
};
</script>

<style></style>
